import { inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { AuthUser } from "../../../core/api/models";
import { AuthenticationService } from "../../../core/api/services";
import { toSignal } from "@angular/core/rxjs-interop";
import { Store } from "@ngrx/store";
import { selectAccessToken } from "../../../store/auth/auth.selectors";
import { StrictHttpResponse } from "../../../core/api/strict-http-response";

@Injectable({
    providedIn: 'root',
})
export class AuthService {
    private store = inject(Store);
    private apiAuthService = inject(AuthenticationService);
    
    readonly accessToken = toSignal(this.store.select(selectAccessToken), { initialValue: null });

    login(email: string, password: string): Observable<{ user: AuthUser; accessToken: string, refreshToken: string }> {
        if(!password){
            console.error("password empty");
        }

        return this.apiAuthService.login({
            body: {
                email,
                password
            }
        }).pipe(
            map((response: any) => ({
                user: response.User!,
                accessToken: response.AccessToken,
                refreshToken: response.RefreshToken
            }))
        );
    }

    logout(email: string, refreshToken: string): Observable<StrictHttpResponse<boolean>> {
        if(!email){
            console.error("Email empty");
        }

        return this.apiAuthService.logout$Response({
            body: {
                email,
                refreshToken
            }
        });
    }

    resetPassword(password: string, resetToken: string) {
        if(!password){
            console.error("Password empty");
      }

        return this.apiAuthService.resetPassword$Response({
            body: {
                password,
                resetToken
            }
        });
    }

    forgotPassword(email: string) {
        if(!email){
            console.error("Email empty");
        }

        return this.apiAuthService.forgotPassword$Response({
            // Body is string type, need to explicitly set it as a string
            body: JSON.stringify(email)
        });
    }   
}